// Minimal port of nenda-autoplayer's src/types/AdSlot.ts - just the shape
// guards.ts reads (`adslot?.ads.length`, `adslot?.numberOfAds`), not the full
// AdItem field list (renderPixel, adnuntius* ids, ...). Never actually
// populated for Foyer: `ScheduleClient.getAdSlot()` always rejects
// (confirmed unreachable, see foyerScheduleClient.ts), so `adslot` on
// `AutoplayerMachineContext.playback.ad` stays `undefined` forever in
// practice - this type exists only so the context's own field declaration
// and the guards that optional-chain into it typecheck.
import { MediaAsset, MediaSource, MediaType } from "./Schedule";

export interface AdSlot {
  ads: AdItem[];
  totalDuration: number;
  numberOfAds: number;
}

/**
 * Minimal port of upstream's `AdItem` - the fields actually referenced
 * across `actions.ts` (`adnuntiusAdId`, `adnuntiusLineItemId`,
 * `renderPixel`) and `selectors.ts`'s `adItemToMediaAsset` (`duration`,
 * `assetLocator`, `assetType`), not the full field list (html,
 * impressionMultiplier, adnuntiusAdUnitId). Never actually constructed for
 * Foyer - `adslot` stays `undefined` forever (see `AdSlot`'s own doc
 * comment) - this exists only so those functions typecheck.
 */
export interface AdItem {
  renderPixel: string;
  adnuntiusAdId: string;
  adnuntiusLineItemId: string;
  duration: number;
  assetLocator: string;
  assetType: MediaType;
}

/** Ported verbatim from upstream's `AdSlot.ts` - the one real function there,
 *  used by `selectors.ts`. Never actually called for Foyer (the Ad branches
 *  it serves are confirmed unreachable), ported for fidelity since it's
 *  trivial and lets selectors.ts port without modification. */
export const adItemToMediaAsset = (adItem: AdItem): MediaAsset => {
  return {
    id: adItem.adnuntiusAdId,
    durationInSeconds: adItem.duration,
    locator: adItem.assetLocator,
    name: adItem.adnuntiusLineItemId,
    type: adItem.assetType,
    source: MediaSource.External,
  };
};
